import { ButtonContentfulModel } from 'src/api/models/Button';
import { ComparisonTableContentfulModel } from 'src/api/models/ComparisonTable';
import { EmailCaptureFormContentfulModel } from 'src/api/models/EmailCaptureForm';
import { FaqContainerContentfulModel } from 'src/api/models/Faq';
import { HeadingContentfulModel } from 'src/api/models/Heading';
import { ImageContentfulModel } from 'src/api/models/Image';
import { ShortParagraphContentModel } from 'src/api/models/ShortParagraph';
import { AiNameGeneratorWidgetContentfulModel } from 'src/api/models/AiNameGeneratorWidget';
import { SeoTableContentfulModel } from 'src/api/models/SEOTable';

import getDynamicButton from './Button.dynamic';
import getDynamicComparisonTable from './ComparisonTable.dynamic';
import getDynamicEmailCaptureForm from './EmailCaptureForm.dynamic';
import getDynamicFAQList from './FAQList.dynamic';
import getDynamicHeading from './Heading.dynamic';
import getDynamicImage from './Image.dynamic';
import getDynamicShortParagraph from './ShortParagraph.dynamic';
import getDynamicAiNameGeneratorWidget from './AiNameGeneratorWidget.dynamic';
import getDynamicSEOTable from './SEOTable';
import getDynamicColoredTextBox from './ColoredTextBox.dynamic';
import { ColoredTextBoxContentModel } from 'src/api/models/ColoredTextBox';
import getDynamicLargeBlockQuote from './LargeBlockQuote.dynamic';
import { LargeBlockQuoteContentModel } from 'src/api/models/LargeBlockQuote';
import getDynamicMemberSpotlight from 'src/functions/dynamicComponents/MemberSpotlight.dynamic';
import { MemberSpotlightContentModel } from 'src/api/models/MemberSpotlight';

interface DynamicComponentsModel {
  [key: string]: (props: unknown) => React.ReactNode;
}

const dynamicComponent: DynamicComponentsModel = {
  ContentfulHeading: (props) => getDynamicHeading(props as HeadingContentfulModel),
  ContentfulButton: (props) => getDynamicButton(props as ButtonContentfulModel),
  ContentfulFaq: (props) => getDynamicFAQList(props as FaqContainerContentfulModel),
  ContentfulShortParagraph: (props) => getDynamicShortParagraph(props as ShortParagraphContentModel),
  ContentfulImage: (props) => getDynamicImage(props as ImageContentfulModel),
  ContentfulComparisonTable: (props) => getDynamicComparisonTable(props as ComparisonTableContentfulModel),
  ContentfulEmailCaptureForm: (props) => getDynamicEmailCaptureForm(props as EmailCaptureFormContentfulModel),
  ContentfulAiGeneratorWidget: (props) =>
    getDynamicAiNameGeneratorWidget(props as AiNameGeneratorWidgetContentfulModel),
  ContentfulSeoTable: (props) => getDynamicSEOTable(props as SeoTableContentfulModel),
  ContentfulColoredTextBox: (props) => getDynamicColoredTextBox(props as ColoredTextBoxContentModel),
  ContentfulLargeBlockQuote: (props) => getDynamicLargeBlockQuote(props as LargeBlockQuoteContentModel),
  ContentfulMemberSpotlight: (props) => getDynamicMemberSpotlight(props as MemberSpotlightContentModel),
};

export default dynamicComponent;
